(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8633:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9657);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5578);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7978);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(102);
/* harmony import */ var _icon_IconHome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5099);
/* harmony import */ var _icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6356);






const ROUTE_MATCH_ELEMENT = [
    {
        route: "/",
        matchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconHome__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            isAct: true
        }),
        nonMatchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconHome__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    },
    {
        route: "/template",
        matchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            isAct: true
        }),
        nonMatchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
    }
];
/**
 * 
 * @example
 * 
 * ```
 * HomePage.getLayout = function getLayout(page: ReactElement) {
    return (
      <>
        {page}
        <BottomNavigation />
      </>
    );
  };
  ```
 */ const BottomNavigation = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Wrapper, {
                children: ROUTE_MATCH_ELEMENT.map((param)=>/*#__PURE__*/ {
                    let { route , matchElement , nonMatchElement  } = param;
                    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Anchor, {
                        href: route,
                        children: router.asPath === route ? matchElement : nonMatchElement
                    }, route);
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrollableDiv, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomNavigation);
const HEIGHT = "56px";
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("section", {
    target: "egppwp20"
})({
    width: "100%",
    height: HEIGHT,
    position: "fixed",
    bottom: 0,
    left: 0,
    display: "flex"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white,
        borderTop: "1px solid ".concat(theme.colors.gray1)
    };
});
const Anchor = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
    target: "egppwp21"
})({
    width: "50%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const ScrollableDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "egppwp22"
})({
    height: HEIGHT,
    appearance: "none"
});


/***/ }),

/***/ 8720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5578);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var _icon_IconAlarm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4677);
/* harmony import */ var _icon_IconMenu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1817);





const DefaultAppBar = ()=>{
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(Wrapper, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(ButtonWrapper, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StyledLink, {
                    href: "/notice",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_icon_IconAlarm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(Button, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_icon_IconMenu__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultAppBar);
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("section", {
    target: "ej887y50"
})({
    position: "sticky",
    top: "0",
    left: "0",
    width: "100%",
    height: "48px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray1
    };
});
const ButtonWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "ej887y51"
})({
    position: "absolute",
    top: "0",
    right: "-12px",
    height: "100%",
    display: "flex"
});
const Button = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    target: "ej887y52"
})({
    all: "unset",
    cursor: "pointer",
    width: "48px",
    height: "48px",
    textAlign: "center"
});
const StyledLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
    target: "ej887y53"
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "48px",
    height: "48px"
});


/***/ }),

/***/ 8337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5578);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6618);
/* harmony import */ var _PortalWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3076);
/* harmony import */ var _StyledMotionScrim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5711);
/* harmony import */ var _constants_motions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9370);
/* harmony import */ var _hooks_scroll_usePreventScroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9168);







const BottomSheet = (param)=>{
    let { setToClose , children , isShowing  } = param;
    (0,_hooks_scroll_usePreventScroll__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(isShowing);
    const onClickScrim = (e)=>{
        if (e.target !== e.currentTarget) return;
        setToClose();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_PortalWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        isShowing: isShowing,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_StyledMotionScrim__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            onClick: onClickScrim,
            variants: _constants_motions__WEBPACK_IMPORTED_MODULE_3__/* .defaultFadeInVariants */ .JD,
            initial: "initial",
            animate: "animate",
            exit: "exit",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledMotionContent, {
                variants: bottomSheetVariants,
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BottomSheet);
const StyledMotionContent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(framer_motion__WEBPACK_IMPORTED_MODULE_6__.m.div, {
    target: "e97q67s0"
})("position:absolute;top:100%;width:100%;min-height:420px;max-height:95%;padding-top:16px;padding-left:20px;padding-right:20px;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, ";border-radius:20px 20px 0 0;overflow:hidden;z-index:1000;");
const bottomSheetVariants = {
    initial: {
        y: 0,
        transition: {
            duration: 0.3,
            ease: _constants_motions__WEBPACK_IMPORTED_MODULE_3__/* .defaultEasing */ .gc
        },
        willChange: "transform"
    },
    animate: {
        y: "-100%",
        transition: {
            duration: 0.3,
            ease: _constants_motions__WEBPACK_IMPORTED_MODULE_3__/* .defaultEasing */ .gc
        },
        willChange: "transform"
    },
    exit: {
        y: 0,
        transition: {
            duration: 0.3,
            ease: _constants_motions__WEBPACK_IMPORTED_MODULE_3__/* .defaultEasing */ .gc
        },
        willChange: "transform"
    }
};


/***/ }),

/***/ 3076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5578);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4654);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4207);



const PortalWrapper = (param)=>{
    let { children , isShowing  } = param;
    const container =  true && document.body;
    return container ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_0__.createPortal)(/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .AnimatePresence */ .M, {
        mode: "wait",
        children: isShowing && children
    }), container) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (PortalWrapper);


/***/ }),

/***/ 5711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6618);


const StyledMotionScrim = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(framer_motion__WEBPACK_IMPORTED_MODULE_1__.m.div, {
    target: "e1apb9yq0"
})("position:fixed;top:0;left:0;z-index:900;width:100vw;height:100%;background-color:rgba(0,0,0,0.3);overflow:hidden;");
/* harmony default export */ __webpack_exports__["Z"] = (StyledMotionScrim);


/***/ }),

/***/ 7043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5578);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9214);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var _icon_IconCancelSmall__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7329);




const TextField = (param)=>{
    let { error , ...rest } = param;
    const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.a)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(InputWrapper, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(Input, {
                    ...rest
                })
            }),
            !!error && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(ErrorMessage, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_icon_IconCancelSmall__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        width: 16,
                        height: 16,
                        stroke: theme.colors.danger,
                        strokeWidth: 2
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("span", {
                        children: error
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextField);
const InputWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e1376d6u0"
})({
    padding: "12px 16px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    boxSizing: "border-box"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray1,
        "&:focus-within": {
            boxShadow: "0 0 0 1px ".concat(theme.colors.gray3, " inset")
        }
    };
});
const Input = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("input", {
    target: "e1376d6u1"
})({
    border: "none",
    backgroundColor: "transparent",
    outline: "none"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1,
        color: theme.colors.black,
        caretColor: theme.colors.secondary,
        "&::placeholder": {
            color: theme.colors.gray3
        }
    };
});
const ErrorMessage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e1376d6u2"
})({
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    "*:first-of-type": {
        marginRight: "8px"
    }
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.text2,
        color: theme.colors.danger
    };
});


/***/ }),

/***/ 6650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9953);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);


function useInput(param) {
    let { initialValue , useDebounce =false , debounceTimeout =150 , parser  } = param;
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue);
    const [debouncedValue, setDebouncedValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialValue);
    const handleDebounceValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()((changedValue)=>{
            setDebouncedValue(changedValue);
        }, debounceTimeout), []);
    const handleChangedValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((changedValue)=>{
        setValue(changedValue);
        if (useDebounce) handleDebounceValue(changedValue);
    }, []);
    const onChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e)=>{
        if (parser) {
            handleChangedValue(parser(e.target.value));
            return;
        }
        handleChangedValue(e.target.value);
    }, []);
    return {
        value,
        setValue,
        debouncedValue,
        onChange
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useInput);


/***/ }),

/***/ 193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9953);

/**
 *
 * @param defaultValue
 * true | false
 *
 * @returns [value, setValue, toggle]
 *
 * @example
 * ```
 * const [value, _, toggle] = useToggle(false);
 * const [value, setValue, toggle] = useToggle(false);
 * ```
 */ const useToggle = (defaultValue)=>{
    const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue);
    const toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        setValue((prev)=>!prev);
    }, []);
    return [
        value,
        setValue,
        toggle
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ }),

/***/ 4061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9953);

const useDidUpdate = (callback, dependencyList)=>{
    const didMountRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        callback();
    }, [
        ...dependencyList
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDidUpdate);


/***/ }),

/***/ 9168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePreventScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9953);

/**
 * `condition`에 따라 body의 스크롤을 막습니다
 *
 * @param condition
 * 스크롤을 방지할 상태 입니다
 *
 */ function usePreventScroll() {
    let condition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (typeof document === "undefined") return;
        if (condition) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        condition
    ]);
}


/***/ }),

/***/ 9657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5578);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(9953);
// EXTERNAL MODULE: ./src/components/carousel/Carousel.tsx + 1 modules
var Carousel = __webpack_require__(8391);
// EXTERNAL MODULE: ./src/components/navigation/BottomNavigation.tsx
var BottomNavigation = __webpack_require__(7652);
// EXTERNAL MODULE: ./src/components/navigation/DefaultAppBar.tsx
var DefaultAppBar = __webpack_require__(8720);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-styled-virtual-2aaf7f2de3/0/cache/@emotion-styled-npm-11.10.0-ee745c48ee-f2a3e9798f.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(102);
// EXTERNAL MODULE: ./src/components/button/LabelButton.tsx
var LabelButton = __webpack_require__(1919);
// EXTERNAL MODULE: ./src/components/icon/IconAdd.tsx
var IconAdd = __webpack_require__(2976);
// EXTERNAL MODULE: ./src/components/icon/IconAlarmAdd.tsx
var IconAlarmAdd = __webpack_require__(9459);
// EXTERNAL MODULE: ./src/components/icon/IconPin.tsx
var IconPin = __webpack_require__(8164);
// EXTERNAL MODULE: ./src/components/icon/IconSetting.tsx
var IconSetting = __webpack_require__(4282);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(2746);
;// CONCATENATED MODULE: ./src/components/route-home/CardItem.tsx



const CardItem = (param)=>{
    let { isChecked , isImportant , name  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        isChecked: isChecked,
        isImportant: isImportant,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                type: "checkbox",
                defaultChecked: isChecked
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NameButton, {
                type: "button",
                children: name
            })
        ]
    });
};
/* harmony default export */ var route_home_CardItem = (CardItem);
const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1pidbgs0"
})({
    display: "flex",
    gap: "8px",
    width: "fit-content",
    maxWidth: "100%",
    paddingTop: "7px",
    paddingBottom: "7px",
    paddingLeft: "8px",
    paddingRight: "10px",
    borderRadius: "8px"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray1
    };
}, (param)=>{
    let { isImportant , theme  } = param;
    return isImportant && importantCss(theme);
}, (param)=>{
    let { isChecked  } = param;
    return isChecked && checkedCss;
});
const importantCss = (theme)=>/*#__PURE__*/ (0,emotion_react_browser_esm.css)({
        backgroundColor: theme.colors.secondary
    });
const checkedCss = /*#__PURE__*/ (0,emotion_react_browser_esm.css)({
    opacity: 0.5
});
const NameButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1pidbgs1"
})({
    all: "unset",
    cursor: "pointer",
    display: "inline-block",
    maxWidth: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button2
    };
});

;// CONCATENATED MODULE: ./src/components/route-home/Card.tsx








const Card = (param)=>{
    let { title , alarmCycle , items  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleHeading, {
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AlarmCycleSpan, {
                children: alarmCycle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PinButton, {
                type: "button",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconPin/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelButton/* default */.Z, {
                        size: "large",
                        withIcon: true,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAdd/* default */.Z, {}),
                            "추가하기"
                        ]
                    }),
                    items.map((param)=>/*#__PURE__*/ {
                        let { id , isChecked , isImportant , name  } = param;
                        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_CardItem, {
                            id: id,
                            isChecked: isChecked,
                            isImportant: isImportant,
                            name: name
                        }, id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomButton, {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAlarmAdd/* default */.Z, {}),
                            " 알림"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomButton, {
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconSetting/* default */.Z, {}),
                            " 설정"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var route_home_Card = (Card);
const Card_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1s1xh9y0"
})({
    position: "relative",
    width: "100%",
    minHeight: "410px",
    height: "100%",
    // NOTE: 100vh - DefaultAppBar - Category - Indicator - Recommend - BottomNavigation
    maxHeight: "calc(100vh - 48px - 56px - 24px - 114px - 56px)",
    padding: "20px",
    // NOTE: bottom button wrapper height
    paddingBottom: "calc(48px)",
    borderRadius: "16px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white
    };
});
const TitleHeading = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1s1xh9y1"
})({
    marginBottom: "4px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.title2,
        color: theme.colors.gray6
    };
});
const AlarmCycleSpan = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1s1xh9y2"
})({
    display: "inline-block",
    marginBottom: "24px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2,
        color: theme.colors.gray4
    };
});
const PinButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1s1xh9y3"
})({
    all: "unset",
    cursor: "pointer",
    position: "absolute",
    top: "11px",
    right: "8px",
    width: "48px",
    height: "48px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const ItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1s1xh9y4"
})({
    flexGrow: "1",
    overflow: "scroll",
    display: "flex",
    flexDirection: "column",
    gap: "8px"
});
const BottomButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1s1xh9y5"
})({
    position: "absolute",
    bottom: "0",
    left: "0",
    width: "100%",
    height: "48px",
    display: "flex"
}, (param)=>{
    let { theme  } = param;
    return {
        borderTop: "1px solid ".concat(theme.colors.gray1)
    };
});
const BottomButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1s1xh9y6"
})({
    all: "unset",
    cursor: "pointer",
    width: "50%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2,
        color: theme.colors.gray5
    };
});

// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-4e7940a640/0/cache/next-npm-13.0.2-b39abd22d0-f6fea2ee34.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(7182);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/button/IconButton.tsx
var IconButton = __webpack_require__(7124);
// EXTERNAL MODULE: ./src/components/chip/Chip.tsx
var Chip = __webpack_require__(5110);
// EXTERNAL MODULE: ./src/components/icon/IconOverflow.tsx
var IconOverflow = __webpack_require__(8070);
// EXTERNAL MODULE: ./src/hooks/common/useToggle.ts
var useToggle = __webpack_require__(193);
;// CONCATENATED MODULE: ./src/components/route-home/CategorySection.tsx







const CategorySettingBottomSheet = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(111), __webpack_require__.e(93)]).then(__webpack_require__.bind(__webpack_require__, 2093)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2093)
            ]
    }
});
const CategorySection = ()=>{
    const [isCategorySettingShowing, setCategorySettingShowing, toggleCategorySettingShowing] = (0,useToggle/* default */.Z)(false);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ChipWrapper, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chip/* default */.Z, {
                                label: "일상",
                                color: "black"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chip/* default */.Z, {
                                label: "일상"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chip/* default */.Z, {
                                label: "일상"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Chip/* default */.Z, {
                                label: "일상"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverflowWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* default */.Z, {
                            onClick: toggleCategorySettingShowing,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconOverflow/* default */.Z, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategorySettingBottomSheet, {
                isShowing: isCategorySettingShowing,
                setToClose: ()=>setCategorySettingShowing(false)
            })
        ]
    });
};
/* harmony default export */ var route_home_CategorySection = (CategorySection);
const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e1sb8v3u0"
})({
    width: "100%",
    height: "56px",
    display: "flex",
    alignItems: "center",
    marginBottom: "8px"
});
const ChipWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1sb8v3u1"
})({
    position: "relative",
    width: "calc(100% - 40px)",
    height: "100%",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    overflowX: "auto",
    "& > *": {
        flexShrink: "0"
    }
});
const OverflowWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1sb8v3u2"
})({
    position: "relative"
}, (param)=>{
    let { theme  } = param;
    return {
        "&::after": {
            content: '""',
            position: "absolute",
            top: "0",
            right: "100%",
            width: "24px",
            height: "100%",
            background: "linear-gradient(to right, rgba(0, 0, 0, 0), ".concat(theme.colors.gray1, " 90%)")
        }
    };
});

// EXTERNAL MODULE: ./src/components/svg/Svg.tsx
var Svg = __webpack_require__(4555);
;// CONCATENATED MODULE: ./src/components/graphic/GraphicEmptyCard.tsx


const GraphicEmptyCard = (param)=>{
    let { width =222 , height =216 , viewBox ="0 0 222 216" , ...rest } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Svg/* default */.Z, {
        width: width,
        height: height,
        viewBox: viewBox,
        ...rest,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            opacity: "0.2",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    opacity: "0.6",
                    cx: "31.7893",
                    cy: "188.975",
                    rx: "28.2424",
                    ry: "3.05324",
                    fill: "#C7C7D0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                    opacity: "0.8",
                    cx: "124.408",
                    cy: "207.454",
                    rx: "79.2911",
                    ry: "8.5443",
                    fill: "#C7C7D0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                    opacity: "0.6",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M28.9562 137.661C35.8482 136.869 40.7933 130.64 40.0013 123.748C39.2094 116.856 32.9804 111.911 26.0884 112.703C19.1964 113.495 14.2514 119.724 15.0433 126.616C15.8352 133.508 22.0643 138.453 28.9562 137.661ZM27.8659 128.209C29.5366 128.017 30.7355 126.506 30.5435 124.836C30.3515 123.165 28.8414 121.966 27.1706 122.158C25.4999 122.35 24.301 123.86 24.493 125.531C24.685 127.202 26.1951 128.401 27.8659 128.209Z",
                            fill: "#9090A0"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            x: "6.69531",
                            y: "118.371",
                            width: "11.0843",
                            height: "36.6221",
                            rx: "3.10356",
                            transform: "rotate(-22.1155 6.69531 118.371)",
                            fill: "#464656"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                            x: "1.4375",
                            y: "128.184",
                            width: "52.909",
                            height: "52.5284",
                            rx: "7.61281",
                            transform: "rotate(-6.55488 1.4375 128.184)",
                            fill: "#C7C7D0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M135.28 43.4072C144.662 44.5021 153.156 37.7841 154.251 28.4021C155.346 19.02 148.628 10.5268 139.245 9.43181C129.863 8.33685 121.37 15.0549 120.275 24.4369C119.18 33.8189 125.898 42.3122 135.28 43.4072ZM136.78 30.5353C139.055 30.8007 141.114 29.1721 141.379 26.8977C141.644 24.6232 140.016 22.5643 137.741 22.2988C135.467 22.0334 133.408 23.662 133.143 25.9364C132.877 28.2108 134.506 30.2698 136.78 30.5353Z",
                    fill: "#9090A0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                    x: "97.2344",
                    y: "8.88672",
                    width: "101.447",
                    height: "141.498",
                    rx: "11.2379",
                    transform: "rotate(12.9128 97.2344 8.88672)",
                    fill: "#464656"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M120.75 24.7969L132.59 26.1787",
                    stroke: "#464656",
                    strokeWidth: "1.516",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M141.859 27.2578L153.699 28.6396",
                    stroke: "#464656",
                    strokeWidth: "1.516",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M45.1492 113.881C46.7625 100.058 59.2764 90.1594 73.0998 91.7727L76.1426 92.1278C91.0502 93.8676 101.725 107.363 99.985 122.271L96.261 154.179C95.7428 158.62 91.7229 161.8 87.2824 161.281L52.7725 157.254C45.8608 156.447 40.9116 150.19 41.7183 143.278L45.1492 113.881Z",
                    fill: "#9090A0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M207.844 132.873C209.458 119.05 199.56 106.536 185.736 104.923L182.693 104.568C167.786 102.828 154.29 113.502 152.55 128.41L148.826 160.319C148.308 164.759 151.488 168.779 155.928 169.297L190.438 173.325C197.35 174.131 203.607 169.182 204.414 162.271L207.844 132.873Z",
                    fill: "#9090A0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M66.6191 82.1402C70.6523 47.5816 101.937 22.836 136.496 26.8692L138.999 27.1613C173.557 31.1946 198.303 62.4794 194.27 97.0379L185.637 171.008C184.435 181.302 175.116 188.673 164.823 187.472L74.4496 176.925C64.1557 175.723 56.7848 166.404 57.9862 156.111L66.6191 82.1402Z",
                    fill: "#C7C7D0"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M168.125 173.612L171.664 143.289C174.729 117.025 155.922 93.2482 129.658 90.183C103.393 87.1177 79.6167 105.924 76.5514 132.189L73.0126 162.511C72.0631 170.647 77.8885 178.012 86.024 178.961L151.675 186.623C159.81 187.573 167.175 181.747 168.125 173.612Z",
                    fill: "#E9E9EE"
                })
            ]
        })
    });
};
/* harmony default export */ var graphic_GraphicEmptyCard = (GraphicEmptyCard);

;// CONCATENATED MODULE: ./src/components/route-home/EmptyCard.tsx





const EmptyCard = ()=>{
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmptyCard_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GraphicWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(graphic_GraphicEmptyCard, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelButton/* default */.Z, {
                    withIcon: true,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAdd/* default */.Z, {}),
                        " 추가하기"
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var route_home_EmptyCard = (EmptyCard);
const EmptyCard_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qiog10"
})({
    width: "100%",
    minHeight: "410px",
    height: "100%",
    borderRadius: "16px",
    overflow: "hidden",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column"
});
const GraphicWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qiog11"
})({
    width: "100%",
    height: "100%",
    flexGrow: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const ButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4qiog12"
})({
    width: "100%",
    height: "48px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        borderTop: "1px solid ".concat(theme.colors.gray1)
    };
});

// EXTERNAL MODULE: ./src/components/navigation/AppBar.tsx
var AppBar = __webpack_require__(54);
// EXTERNAL MODULE: ./src/components/portal/BottomSheet.tsx
var BottomSheet = __webpack_require__(8337);
// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(6618);
// EXTERNAL MODULE: ./src/components/portal/PortalWrapper.tsx
var PortalWrapper = __webpack_require__(3076);
// EXTERNAL MODULE: ./src/components/portal/StyledMotionScrim.ts
var StyledMotionScrim = __webpack_require__(5711);
// EXTERNAL MODULE: ./src/constants/motions.ts
var motions = __webpack_require__(9370);
// EXTERNAL MODULE: ./src/hooks/scroll/usePreventScroll.ts
var usePreventScroll = __webpack_require__(9168);
;// CONCATENATED MODULE: ./src/components/portal/Dialog.tsx








/**
 * @example
 *```tsx
  <Dialog
      isShowing={isShowing}
      setToClose={close}
      content={
        <>
          <Dialog.ContentTitle>진짜 닫을거?</Dialog.ContentTitle>
          <Dialog.ContentBody>어쩌구 저쩌구</Dialog.ContentBody>
        </>
      }
      leftButton={<Dialog.Button onClick={close}>닫기</Dialog.Button>}
      rightButton={<Dialog.WarningButton onClick={close}>진짜 닫기</Dialog.WarningButton>}
  />
 *```
 */ const Dialog = (param)=>{
    let { setToClose , isShowing , content , leftButton , rightButton  } = param;
    (0,usePreventScroll/* default */.Z)(isShowing);
    const onClickScrim = (e)=>{
        if (e.target !== e.currentTarget) return;
        setToClose();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PortalWrapper/* default */.Z, {
        isShowing: isShowing,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Scrim, {
            onClick: onClickScrim,
            variants: motions/* defaultFadeInVariants */.JD,
            initial: "initial",
            animate: "animate",
            exit: "exit",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MotionWrapper, {
                variants: motions/* defaultFadeInUpVariants */._5,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentWrapper, {
                        children: content
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dialog_ButtonWrapper, {
                        children: [
                            leftButton,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalDivider, {}),
                            rightButton
                        ]
                    })
                ]
            })
        })
    });
};
const Scrim = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(StyledMotionScrim/* default */.Z, {
    target: "e31iz6c0"
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const MotionWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(motion_minimal.m.div, {
    target: "e31iz6c1"
})({
    width: "17.5rem",
    borderRadius: "16px"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white
    };
});
const ContentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e31iz6c2"
})({
    width: "100%",
    padding: "24px 16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px"
}, (param)=>{
    let { theme  } = param;
    return {
        borderBottom: "1px solid ".concat(theme.colors.gray2)
    };
});
const Dialog_ButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e31iz6c3"
})({
    width: "100%",
    height: "56px",
    display: "flex"
});
const HorizontalDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e31iz6c4"
})({
    height: "100%",
    width: "1px"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray2
    };
});
const EmptyButtonCss = /*#__PURE__*/ (0,emotion_react_browser_esm.css)({
    all: "unset",
    cursor: "pointer",
    width: "50%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const Button = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e31iz6c5"
})({
    ...EmptyButtonCss
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button2,
        color: theme.colors.gray4
    };
});
const WarningButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e31iz6c6"
})({
    ...EmptyButtonCss
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button2,
        color: theme.colors.danger
    };
});
const ContentTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e31iz6c7"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.subTitle,
        color: theme.colors.gray6
    };
});
const ContentBody = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e31iz6c8"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1,
        color: theme.colors.gray4
    };
});
Dialog.ContentTitle = ContentTitle;
Dialog.ContentBody = ContentBody;
Dialog.Button = Button;
Dialog.WarningButton = WarningButton;
/* harmony default export */ var portal_Dialog = (Dialog);

// EXTERNAL MODULE: ./src/components/text-field/TextField.tsx
var TextField = __webpack_require__(7043);
// EXTERNAL MODULE: ./src/components/toggle/ToggleSwitch.tsx
var ToggleSwitch = __webpack_require__(6744);
// EXTERNAL MODULE: ./src/hooks/common/useInput.ts
var useInput = __webpack_require__(6650);
;// CONCATENATED MODULE: ./src/components/route-home/ListSettingBottomSheet.tsx










const ListSettingBottomSheet = (param)=>{
    let { isShowing , setToClose  } = param;
    const { value: listName , onChange: onChangeListName , debouncedValue: debouncedListName  } = (0,useInput/* default */.Z)({
        initialValue: "",
        useDebounce: true
    });
    const [isDialogShowing, setIsDialogShowing] = (0,react.useState)(false);
    const isSubmitDisabled = debouncedListName.length === 0;
    const handleListSettingComplete = ()=>{
        // TODO: 리스트 설정 완료 시 실행할 로직 추가
        setToClose();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomSheet["default"], {
        isShowing: isShowing,
        setToClose: setToClose,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppBar/* default */.Z, {
                backButtonType: "cancel",
                title: "리스트 설정",
                rightElement: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelButton/* default */.Z, {
                    disabled: isSubmitDisabled,
                    onClick: handleListSettingComplete,
                    size: "large",
                    children: "완료"
                }),
                onClickBackButton: setToClose
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                style: {
                    marginTop: 8
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                    value: listName,
                    onChange: onChangeListName
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SettingOptionList, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Option, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: "매일 반복"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleSwitch/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Option, {
                        isDeleteOption: true,
                        onClick: ()=>{
                            setIsDialogShowing(true);
                        },
                        children: "리스트 삭제하기"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_Dialog, {
                setToClose: ()=>{
                    setIsDialogShowing(false);
                },
                isShowing: isDialogShowing,
                content: DialogContent,
                leftButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_Dialog.Button, {
                    onClick: ()=>{
                        setIsDialogShowing(false);
                    },
                    children: "아니요"
                }),
                rightButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_Dialog.WarningButton, {
                    children: "삭제하기"
                })
            })
        ]
    });
};
/* harmony default export */ var route_home_ListSettingBottomSheet = (ListSettingBottomSheet);
const SettingOptionList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "e1rvo8xv0"
})("margin-top:16px;");
const Option = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "e1rvo8xv1"
})({
    paddingBlock: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&:last-child": {
        border: 0
    }
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1,
        ...theme.divider
    };
}, (props)=>props.isDeleteOption && {
        color: props.theme.colors.danger
    });
const DialogContent = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_Dialog.ContentTitle, {
            children: "리스트를 삭제할까요?"
        }),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_Dialog.ContentBody, {
            children: "리스트 안의 소지품까지 모두 사라져요."
        })
    ]
});

// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(4207);
// EXTERNAL MODULE: ./.yarn/cache/hey-listen-npm-1.0.8-adb7dae9da-6bad60b367.zip/node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(6025);
// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(9131);
// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(9412);
;// CONCATENATED MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/animation/animation-controls.mjs




/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    let hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    const pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    const subscribers = new Set();
    const controls = {
        subscribe(visualElement) {
            subscribers.add(visualElement);
            return () => void subscribers.delete(visualElement);
        },
        start(definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                const animations = [];
                subscribers.forEach((visualElement) => {
                    animations.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride,
                    }));
                });
                return Promise.all(animations);
            }
            else {
                return new Promise((resolve) => {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve,
                    });
                });
            }
        },
        set(definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach((visualElement) => {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop() {
            subscribers.forEach((visualElement) => {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount() {
            hasMounted = true;
            pendingAnimations.forEach(({ animation, resolve }) => {
                controls.start(...animation).then(resolve);
            });
            return () => {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(9357);
;// CONCATENATED MODULE: ./.yarn/__virtual__/framer-motion-virtual-12ae7d66a8/0/cache/framer-motion-npm-7.5.1-450b8d268a-7785459f34.zip/node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimationControls() {
    const controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}
const useAnimation = (/* unused pure expression or super */ null && (useAnimationControls));



// EXTERNAL MODULE: ./src/components/icon/IconCancelSmall.tsx
var IconCancelSmall = __webpack_require__(7329);
;// CONCATENATED MODULE: ./src/components/tag/Tag.tsx




const Tag = /*#__PURE__*/ (0,react.forwardRef)(function Tag(param, forwardedRef) {
    let { value , onClick , onClickCancel , ...rest } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Tag_Button, {
        type: "button",
        ref: forwardedRef,
        isShowingIconCancel: Boolean(onClickCancel),
        onClick: onClick,
        ...rest,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: value
            }),
            onClickCancel && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCancelSmall/* default */.Z, {
                onClick: onClickCancel
            })
        ]
    });
});
const Tag_Button = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "ekjb3rl0"
})({
    all: "unset",
    cursor: "pointer",
    maxWidth: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    borderRadius: "8px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button2,
        backgroundColor: theme.colors.gray1,
        color: theme.colors.gray6
    };
}, (param)=>{
    let { isShowingIconCancel  } = param;
    return isShowingIconCancel ? {
        paddingTop: "7px",
        paddingBottom: "7px",
        paddingLeft: "8px",
        paddingRight: "4px"
    } : {
        padding: "7px 8px"
    };
});
/* harmony default export */ var tag_Tag = (Tag);

// EXTERNAL MODULE: ./src/hooks/life-cycle/useDidUpdate.ts
var useDidUpdate = __webpack_require__(4061);
;// CONCATENATED MODULE: ./src/components/route-home/RecommendSection.tsx








const HIDE_BOTTOM_POS = 84;
const RecommendSection = ()=>{
    const { onDragStart , onDragEnd , onClickToggleButton , animationControls  } = useSectionVisible();
    // TODO: API 부착 이후 대응
    const testFn = ()=>{
        ;
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
        mode: "wait",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RecommendSection_Wrapper, {
            animate: animationControls,
            drag: "y",
            dragElastic: 0,
            dragMomentum: false,
            dragConstraints: {
                top: 0,
                bottom: HIDE_BOTTOM_POS
            },
            onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DragHandlerButton, {
                    type: "button",
                    onClick: onClickToggleButton,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DragHandlerSpan, {})
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionText, {
                    children: "날씨가 부쩍 추워졌어요. 이런 건 어때요?"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RecommendSection_ItemWrapper, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tag_Tag, {
                            value: "핫팩",
                            onClickCancel: testFn
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tag_Tag, {
                            value: "겉옷",
                            onClickCancel: testFn
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var route_home_RecommendSection = (RecommendSection);
const RecommendSection_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(motion_minimal.m.section, {
    target: "eedb1e0"
})({
    position: "fixed",
    bottom: "54px",
    left: "0",
    width: "100%",
    height: "104px",
    borderRadius: "20px 20px 0 0",
    display: "flex",
    flexDirection: "column"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white,
        padding: theme.size.layoutPadding,
        paddingTop: "28px",
        paddingBottom: "20px"
    };
});
const DragHandlerButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "eedb1e1"
})({
    all: "unset",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const DragHandlerSpan = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "eedb1e2"
})({
    width: "2.125rem",
    height: "4px",
    borderRadius: "10px"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray2
    };
});
const SuggestionText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "eedb1e3"
})({
    marginBottom: "8px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2,
        color: theme.colors.gray4
    };
});
const RecommendSection_ItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eedb1e4"
})({
    display: "flex",
    gap: "8px",
    marginBottom: "22px"
});
const useSectionVisible = ()=>{
    const animationControls = useAnimationControls();
    const [isVisible, setIsVisible, toggleVisible] = (0,useToggle/* default */.Z)(true);
    const isDragRef = (0,react.useRef)(false);
    const startAnimationDependsOnIsVisble = ()=>{
        if (isVisible) {
            animationControls.start(visibleMotion);
        } else {
            animationControls.start(hideMotion);
        }
    };
    const onDragStart = ()=>{
        isDragRef.current = true;
    };
    const onDragEnd = (_, info)=>{
        const shouldVisible = info.velocity.y < -50 && info.offset.y < 0;
        setIsVisible(shouldVisible);
        startAnimationDependsOnIsVisble();
        setTimeout(()=>{
            isDragRef.current = false;
        }, 0);
    };
    const onClickToggleButton = ()=>{
        if (isDragRef.current) return;
        toggleVisible();
    };
    (0,useDidUpdate/* default */.Z)(()=>{
        startAnimationDependsOnIsVisble();
    }, [
        isVisible
    ]);
    return {
        onDragStart,
        onDragEnd,
        onClickToggleButton,
        animationControls
    };
};
const visibleMotion = {
    y: 0,
    transition: {
        duration: 0.5,
        ease: motions/* defaultEasing */.gc
    }
};
const hideMotion = {
    y: HIDE_BOTTOM_POS,
    transition: {
        duration: 0.5,
        ease: motions/* defaultEasing */.gc
    }
};

;// CONCATENATED MODULE: ./src/components/route-home/TemplateItemSettingBottomSheet.tsx










const TemplateItemSettingBottomSheet = (param)=>{
    let { isShowing , setToClose  } = param;
    const { value: itemName , onChange: onChangeItemName , debouncedValue: debouncedItemName  } = (0,useInput/* default */.Z)({
        initialValue: "",
        useDebounce: true
    });
    const [isDialogShowing, setIsDialogShowing] = (0,react.useState)(false);
    const isSubmitDisabled = debouncedItemName.length === 0 || debouncedItemName.length >= 30;
    const handleTemplateItemSettingComplete = ()=>{
        // TODO: 소지품 설정 완료 시 실행할 로직 추가
        setToClose();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomSheet["default"], {
        isShowing: isShowing,
        setToClose: setToClose,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppBar/* default */.Z, {
                backButtonType: "cancel",
                title: "소지품 설정",
                rightElement: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelButton/* default */.Z, {
                    disabled: isSubmitDisabled,
                    onClick: handleTemplateItemSettingComplete,
                    size: "large",
                    children: "완료"
                }),
                onClickBackButton: setToClose
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                style: {
                    marginTop: 8
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                    value: itemName,
                    onChange: onChangeItemName,
                    error: debouncedItemName.length >= 30 ? "최대 n자까지 입력 가능합니다." : undefined
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TemplateItemSettingBottomSheet_SettingOptionList, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TemplateItemSettingBottomSheet_Option, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: "중요 소지품"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleSwitch/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TemplateItemSettingBottomSheet_Option, {
                        isDeleteOption: true,
                        onClick: ()=>{
                            setIsDialogShowing(true);
                        },
                        children: "소지품 삭제하기"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_Dialog, {
                setToClose: ()=>{
                    setIsDialogShowing(false);
                },
                isShowing: isDialogShowing,
                content: TemplateItemSettingBottomSheet_DialogContent,
                leftButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_Dialog.Button, {
                    onClick: ()=>{
                        setIsDialogShowing(false);
                    },
                    children: "아니요"
                }),
                rightButton: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_Dialog.WarningButton, {
                    children: "삭제하기"
                })
            })
        ]
    });
};
/* harmony default export */ var route_home_TemplateItemSettingBottomSheet = (TemplateItemSettingBottomSheet);
const TemplateItemSettingBottomSheet_SettingOptionList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "edh9epk0"
})("margin-top:16px;");
const TemplateItemSettingBottomSheet_Option = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "edh9epk1"
})({
    paddingBlock: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&:last-child": {
        border: 0
    }
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1,
        ...theme.divider
    };
}, (props)=>props.isDeleteOption && {
        color: props.theme.colors.danger
    });
const TemplateItemSettingBottomSheet_DialogContent = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_Dialog.ContentTitle, {
            children: "소지품을 삭제할까요?"
        }),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_Dialog.ContentBody, {
            children: "삭제 후에는 복구가 어려워요."
        })
    ]
});

;// CONCATENATED MODULE: ./src/pages/index.page.tsx











const MOCK_CARDS = [
    {
        title: "출근할 때 필수템",
        alarmCycle: "매주 월 오후 6:00",
        id: "0",
        items: [
            {
                id: "0",
                isChecked: false,
                name: "중요 소지품",
                isImportant: true
            },
            {
                id: "1",
                isChecked: false,
                name: "비중요 소지품",
                isImportant: false
            },
            {
                id: "2",
                isChecked: true,
                name: "체크 + 중요 소지품",
                isImportant: true
            },
            {
                id: "3",
                isChecked: true,
                name: "체크 + 비중요 소지품",
                isImportant: false
            },
            {
                id: "4",
                isChecked: false,
                name: "엄청 긴 소지품소지품소지품소지품소지품소지품소지품소지품소지품소지품",
                isImportant: false
            },
            {
                id: "5",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            },
            {
                id: "6",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            },
            {
                id: "7",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            },
            {
                id: "8",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            },
            {
                id: "9",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            },
            {
                id: "10",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            },
            {
                id: "11",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            },
            {
                id: "12",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            },
            {
                id: "13",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            },
            {
                id: "14",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            },
            {
                id: "15",
                isChecked: false,
                name: "스크롤을 위한 소지품",
                isImportant: false
            }
        ]
    },
    {
        title: "혹한기에서 살아남기",
        alarmCycle: "매주 화 오후 6:00",
        id: "1",
        items: [
            {
                id: "16",
                isChecked: false,
                name: "중요 소지품",
                isImportant: true
            },
            {
                id: "17",
                isChecked: false,
                name: "비중요 소지품",
                isImportant: false
            },
            {
                id: "18",
                isChecked: true,
                name: "체크 + 중요 소지품",
                isImportant: true
            },
            {
                id: "19",
                isChecked: true,
                name: "체크 + 비중요 소지품",
                isImportant: false
            }
        ]
    }
];
const HomePage = ()=>{
    const [carouselWrapper, setCarouselWrapper] = (0,react.useState)(null);
    // TODO: Home Card 컴포넌트 개발 시 해당 컴포넌트 내부로 이동 예정
    const [isShowingList, setIsShowingList] = (0,react.useState)(false);
    const [isShowingItem, setIsShowingItem] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_CategorySection, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Carousel/* default.Wrapper */.Z.Wrapper, {
                ref: setCarouselWrapper,
                children: [
                    MOCK_CARDS.map((param)=>/*#__PURE__*/ {
                        let { id , title , alarmCycle , items  } = param;
                        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default.Item */.Z.Item, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_Card, {
                                id: id,
                                title: title,
                                alarmCycle: alarmCycle,
                                items: items
                            })
                        }, id);
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default.Item */.Z.Item, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_EmptyCard, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default.Indicator */.Z.Indicator, {
                carouselWrapper: carouselWrapper
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_RecommendSection, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                onClick: ()=>{
                    setIsShowingList(true);
                },
                type: "button",
                children: "리스트 설정 BottomSheet 열기"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_ListSettingBottomSheet, {
                isShowing: isShowingList,
                setToClose: ()=>{
                    setIsShowingList(false);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                onClick: ()=>{
                    setIsShowingItem(true);
                },
                type: "button",
                children: "소지품 설정 BottomSheet 열기"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_home_TemplateItemSettingBottomSheet, {
                isShowing: isShowingItem,
                setToClose: ()=>{
                    setIsShowingItem(false);
                }
            })
        ]
    });
};
HomePage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultAppBar/* default */.Z, {}),
            page,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomNavigation/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var index_page = (HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [618,862,43,70,774,888,179], function() { return __webpack_exec__(8633); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);